import { AfterViewInit, Component, inject, ViewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ModalService } from 'src/utils/modal.service';
import { ModalComponent } from './components/modal/modal.component';
import { ToastService } from 'src/utils/toast.service';
import { ToastComponent } from './components/toast/toast.component';
import { BaseModalComponent } from './components/base-modal/base-modal.component';
import { BaseModalService } from 'src/utils/base-modal.service';
import { OptionsModalComponent } from './components/options-modal/options-modal.component';
import { OptionsModalService } from 'src/utils/options-modal.service';
import { InputModalComponent } from './components/input-modal/input-modal.component';
import { TokenExpirationMonitorService } from 'src/core/services/auth/token-expiration-monitor.service';
import { SpinnerComponent } from './components/spinner/spinner.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ModalComponent, ToastComponent, BaseModalComponent, OptionsModalComponent, InputModalComponent, SpinnerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements AfterViewInit {
  public modalService = inject(ModalService);
  public toastService = inject(ToastService);
  private readonly baseModalService = inject(BaseModalService);
  public optionsModalService = inject(OptionsModalService);
  private readonly tokenMonitor = inject(TokenExpirationMonitorService);
  @ViewChild(BaseModalComponent) baseModal!: BaseModalComponent;

  constructor() {
    // Inicializar el monitor de expiración de tokens
    this.tokenMonitor.startMonitoring();
  }

  ngAfterViewInit() {
    this.baseModalService.register(this.baseModal);
  }

  showToast(): void {
    this.toastService.showToast(
      'fi fi-ss-check-circle text-[24px] text-[#17BF33]',
      '¡Toast mostrado exitosamente!',
      'success'
    );
  }

  showModal(): void {
    this.modalService.showModal({
      title: '¡Tu cuenta está casi lista!',
      message:
        'Completa la segmentación para activar todas las herramientas de PRECREDIT Advanced.',
      onConfirm: () => {},
      modalType: 'success',
      iconClass: 'fi fi-ss-check-circle text-4xl text-success',
      btnCancelar: false,
      continueButtonText: 'Continuar',
    });
  }
  showModal2(): void {
    this.modalService.showModal({
      title: '¿Estás seguro de que deseas cerrar sesión?',
      message: '',
      onConfirm: () => {},
      modalType: 'confirmation',
      btnCancelar: true,
      cancelButtonText: 'Cancelar',
      continueButtonText: 'Cerrar sesión',
      iconClass: 'fi fi-sr-exclamation text-4xl text-error',
    });
  }
  showModal3(): void {
    this.modalService.showModal({
      title: '¿Deseas cancelar?',
      message:
        'Solo faltan unos pasos para completar tu cuenta en PRECREDIT Advanced. Salir ahora dejará tu registro incompleto.',
      onConfirm: () => {},
      modalType: 'warning',
      iconClass: 'fi fi-sr-diamond-exclamation text-4xl text-error',

      btnCancelar: true,
      cancelButtonText: 'Cancelar',
      continueButtonText: 'Salir sin guardar',
    });
  }
}
